import React from 'react'
import PropTypes from 'prop-types'
import {useLocation} from 'react-router-dom'

export class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const {scrollbarRef} = this.props
      scrollbarRef?.current?.scrollToTop()
    }
  }

  render() {
    return this.props.children
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  scrollbarRef: PropTypes.shape({
    current: PropTypes.object,
  }).isRequired,
}

export default withLocation(ScrollToTop)

function withLocation(Component) {
  return function AzubiIdContainer(props) {
    const location = useLocation()
    return <Component {...props} location={location} />
  }
}
